import DateTools from 'utils/dates/dateTools'
import Colors from 'utils/colors/colors'

function getMetaFlag(dp) {
  if ( dp.meta && dp.meta.flag ) {
    return dp.meta.flag;
  }
  return null;
}

const formatLinesSeries = ({ data, name, color, extent, lastCommonYear = null, dashedLineStyle = false, formatMessage }) => {
  let values = [];

  let orderedData = data.sort((a, b) => { return a.time > b.time ? 1 : -1} );
  orderedData = orderedData.filter( (item) => {
    let dataItemYear = DateTools.getYearFromDateString(item.time);
    return dataItemYear >= extent[0] && dataItemYear <= extent[1] && item.value != null;
  });

  orderedData.forEach( (item, index) => {
      let time_year = item.time_year; // DateTools.getYearFromDateString(item.time);
      let flag_note = getMetaFlag( item );
      let markerEnabled = (index === 0) || (index === (orderedData.length - 1)) || time_year === lastCommonYear;
      let value = {
        x: DateTools.getYearFromDateString(item.time),
        y: item.value,
        marker: {
          enabled: markerEnabled
        },
        notes: flag_note
      };

      values.push( value );
        // add first and last values (and common last value too)
  });

  let markerEnabled = false
  if (values.length < 2) markerEnabled = true

  let dashStyle = 'Solid';
  if (dashedLineStyle) {
    dashStyle = dashedLineStyle;
  }

  let lineName = name;

  return {
    name: lineName,
    color: Colors.colorToRGBA(color),
    data: values,
    dashStyle: dashStyle,
    lineWidth: 2,
    marker: {
      enabled: markerEnabled,
      radius: 3
    }
  };
}

const linesChartAdapter = {
  formatLinesSeries
}
export default linesChartAdapter;



// WEBPACK FOOTER //
// ./src/modules/Charts/DecoupledLines/DecoupledLinesChart/LinesChartAdapter.js